import { createContext, useContext } from 'react';

export interface SavedContentContextProps {
  savedContentIds: string[];
  isLoading: boolean;
}

export const SavedContentContext = createContext<SavedContentContextProps | null>(null);

export const useSavedContentContext = () => {
  const context = useContext(SavedContentContext);

  if (context === null) {
    throw new Error('useSavedContentContext must be used within a SavedContentProvider');
  }

  return context;
};
